import React from 'react';
import { useParams } from 'react-router';

import { useQuestionnaireAnswer } from '@/features/constructor/hooks';
import { Answer } from '@/features/constructorCommon';

export const QuestionnaireAnswer = ({answerProp, questionId, onCreated, ...props}) => {
  const { id } = useParams();
  const {
    handleCreate,
    handleUpdate,
    handleDelete,
    isCreating,
    isUpdating,
    isDeleting
  } = useQuestionnaireAnswer({questionnaireId: id});

  return (
    <Answer answerProp={answerProp} questionId={questionId} onCreated={onCreated}
            handleUpdate={handleUpdate}
            handleDelete={handleDelete}
            handleCreate={handleCreate}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDeleting={isDeleting}
            type="questionnaire"
            {...props} />
  )
};
